import React from "react";
import UserInfoCard from "./UserInfoCard";

const inputClass =
  "w-full p-2.5 text-xs md:text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white text-gray-700 min-w-0";

export default function UserSearchSection({
  searchEmail,
  setSearchEmail,
  searchContactNo,
  setSearchContactNo,
  onSearch,
  searching,
  onClearError,
  searchedUser,
}) {
  return (
    <div className="mb-6 min-w-0">
      <h4 className="text-base md:text-lg font-bold mb-4 text-gray-800">
        Search User
      </h4>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div className="min-w-0">
          <label
            htmlFor="searchEmail"
            className="block text-sm font-semibold text-gray-700 mb-2">
            Email
          </label>
          <input
            id="searchEmail"
            type="email"
            value={searchEmail}
            onChange={(e) => {
              setSearchEmail(e.target.value);
              onClearError?.();
            }}
            className={inputClass}
            placeholder="user@example.com"
          />
        </div>
        <div className="min-w-0">
          <label
            htmlFor="searchContactNo"
            className="block text-sm font-semibold text-gray-700 mb-2">
            Contact Number
          </label>
          <input
            id="searchContactNo"
            type="text"
            value={searchContactNo}
            onChange={(e) => {
              setSearchContactNo(e.target.value);
              onClearError?.();
            }}
            className={inputClass}
            placeholder="+1234567890"
          />
        </div>
      </div>
      <button
        type="button"
        onClick={onSearch}
        disabled={searching}
        className="px-4 sm:px-6 py-2.5 bg-red-500 text-white rounded-lg hover:bg-red-600 disabled:bg-gray-400 disabled:cursor-not-allowed text-sm font-semibold shadow-md transition-colors">
        {searching ? "Searching..." : "Search User"}
      </button>

      {searchedUser && (
        <div className="mt-6 min-w-0">
          <UserInfoCard user={searchedUser} />
        </div>
      )}
    </div>
  );
}
